import { Component, OnInit } from '@angular/core';
import packageData from  "../mockdata/packageData.json";

@Component({
  selector: 'cmpts-package-form',
  templateUrl: './package-form.component.html',
  styleUrls: ['./package-form.component.css']
})
export class PackageFormComponent implements OnInit {
  packageDatas = packageData;
  constructor() { }

  ngOnInit() {
    
  }
  
}
